export default class {
    canEdit = true;
    editStartTime = '';

    constructor(data = {}) {
        for (let key in this) {
            if (data[key] !== undefined) {
                if (data[key] !== 'null') {
                    this[key] = data[key];
                } else {
                    this[key] = '';
                }
            }
        }
    }
}
